import { debug } from "util";

cb.define([], function () {
  var AA_aa_enumextlist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      // var self = this;
      // viewmodel.on('beforeEdit', function (args) {
      //   var promise = new cb.promise();
      //     var currentRow = viewmodel.getGridModel().getRow(args.params.params.index);
      //     if(currentRow!=null ){
      //       var url = '/enum/enumCheck';
      //       var params=currentRow;
      //       var proxy = cb.rest.DynamicProxy.create({ ensure: { url: url, method: "POST" } });
      //       proxy.ensure(params, function (err, result) {
      //         if (err) {
      //           cb.utils.alert(err.message, 'error');
      //           return ;
      //         }
      //         promise.resolve();
      //       });
      //     }
      //     return promise;
      // });
    }
  }
  try {
    module.exports = AA_aa_enumextlist_VM_extend;
  } catch (error) {

  }
  return AA_aa_enumextlist_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_enumextlist_VM.Extend.js